<template>
  <VpModal
    name="product-seo-info-modal"
    _class="vp-w-1/2 vp-h-3/4"
    title="How to Format"
  >
    <div class="vp-p-4">
      <help-card title="Global Variables">
        <p>You can use these global variables in your SEO values.</p>
        <p class="vp-m-0">Available Variables:</p>
        <ul class="vp-m-0">
          <li>{{ name }}</li>
          <li>{{ price }}</li>
          <li>{{ description }}</li>
          <li>{{ categories }}</li>
          <li>{{ weight }}</li>
          <li>{{ sku }}</li>
          <li>{{ rating }}</li>
          <li>{{ measurement }}</li>
        </ul>
      </help-card>

      <help-card class="vp-mt-2" title="Custom Variables">
        <p>
          You can also use custom variables that you have defined. Use the
          format <code>{{ "{" + "{" }}variable_key{{ "}" + "}" }}</code
          >.
        </p>
        <p>
          Need more variables?
          <router-link
            :to="{ name: 'seo-variables' }"
            class="vp-text-primary-500 vp-underline"
          >
            Manage Custom Variables
          </router-link>
        </p>
      </help-card>
    </div>
  </VpModal>
</template>

<script>
import HelpCard from "components/src/help/card.vue";

export default {
  components: {
    HelpCard,
  },
  data() {
    return {
      name: "{{name}}",
      price: "{{price}}",
      description: "{{description}}",
      categories: "{{categories}}",
      weight: "{{weight}}",
      sku: "{{sku}}",
      rating: "{{rating}}",
      measurement: "{{measurement}}",
    };
  },
};
</script>
